import gql from 'graphql-tag';

export const mutationUpdateRemoteItemPermission = gql`
  mutation updateRemoteItemPermission (
    $integrationID: DokkioID!
    $email: String
    $permissionID: String
    $remoteItemRemoteID: ID
    $remoteUserRemoteID: ID
    $role: RemoteItemPermissionRole!
  ) {
    updateRemoteItemPermission (
      integrationID: $integrationID
      email: $email
      permissionID: $permissionID
      remoteItemRemoteID: $remoteItemRemoteID
      remoteUserRemoteID: $remoteUserRemoteID
      role: $role
    )
  }
`;
export default mutationUpdateRemoteItemPermission;
